import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { WHITE, BASE_SPACING, MEDIA_QUERIES } from '../styles';
import Wrapper from '../components/Wrapper';
import Button, { TYPES } from '../components/Button';
import { openConfirm } from '../redux/app';
import { navigateBack } from '../utils';

const s = StyleSheet.create({
  root: {
    width: '100%',
    backgroundColor: WHITE,
    padding: `${BASE_SPACING}px 0`,
  },
  buttonWrapper: {
    width: '100%',
    paddingTop: BASE_SPACING,
    display: 'flex',
    justifyContent: 'space-between',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      justifyContent: 'flex-end',
    },
  },
  button: {
    flexBasis: '49%',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      flexBasis: 'auto',
      marginLeft: 10,
    },
  },
});

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: this.mapProps(),
      invalidDate: false,
      didChange: false,
    };
  }

  static mapDispatchToProps = (fn) => (dispatch, ownProps) => {
    return {
      ...fn(dispatch, ownProps),
      openConfirm: (props) => dispatch(openConfirm(props)),
    };
  };

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.defaultValues) !==
      JSON.stringify(this.props.defaultValues)
    ) {
      this.setState({
        values: this.mapProps(),
      });
    }
  }

  mapProps = () => {
    return this.props.defaultValues || {};
  };

  onChange = (name) => (e) => {
    const newValue =
      e?.currentTarget?.type === 'checkbox'
        ? e.currentTarget.checked
        : e.value !== undefined
        ? e.value
        : e.currentTarget.value;

    const values = {
      ...this.state.values,
      [name]: newValue,
    };

    this.setState({
      values,
      didChange: JSON.stringify(values) !== JSON.stringify(this.mapProps()),
    });
  };

  onKeyUp = (name) => (e) => {
    const invalidDate =
      e?.currentTarget?.type === 'date' && !e?.currentTarget?.checkValidity();
    if (name.toLowerCase().includes('color')) {
      const values = { ...this.state.values };
      this.setState({
        values,
        invalidDate,
        didChange: JSON.stringify(values) !== JSON.stringify(this.mapProps()),
      });
    }
  };

  onKeyUp = (name) => (e) => {
    if (name.toLowerCase().includes('color')) {
      const values = { ...this.state.values };
      this.setState({
        values,
        didChange: JSON.stringify(values) !== JSON.stringify(this.mapProps()),
      });
    }
  };

  discardChanges = (close) => {
    this.setState(
      {
        values: this.mapProps(),
        didChange: false,
      },
      () => {
        if (close) {
          close();
        }
        navigateBack();
      }
    );
  };

  discard = () => {
    if (!this.state.didChange) {
      return this.discardChanges();
    }

    this.props.openConfirm({
      title: {
        messageId: 'app.discard.changes.title',
      },
      message: {
        messageId: 'app.discard.changes.message',
      },
      buttons: [
        {
          messageId: 'app.discard.changes.button',
          onClick: this.discardChanges,
        },
      ],
    });
  };

  isValid = () => {
    return true;
  };

  save = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(
      { displayError: !this.isValid(), isSubmitting: true },
      async () => {
        if (!this.state.displayError && !this.state.invalidDate) {
          await this.props.save(this.state.values);
          this.setState({ didChange: false, isSubmitting: false });
        }
      }
    );
  };

  createFields = (fields) => {
    return fields.map(({ component, name, required, ...props }) => {
      const checkedProp =
        props.type === 'checkbox'
          ? { checked: this.state.values[name] || false }
          : null;

      return React.createElement(component, {
        label: `${this.nameSpace}.${name}`,
        key: name,
        value: this.state.values[name] || '',
        onChange: this.onChange(name),
        onKeyUp: this.onKeyUp(name),
        error:
          this.state.displayError &&
          required &&
          !this.state.values[name] &&
          `${this.nameSpace}.error.${name}`,
        required,
        ...props,
        ...checkedProp,
      });
    });
  };

  static Wrapper = (props) => (
    <form className={css(s.root)} onSubmit={this.save}>
      <Wrapper {...props} />
    </form>
  );

  Buttons = ({ cancelMessageId }) => (
    <div className={css(s.buttonWrapper)}>
      <Button
        messageId={
          this.state.didChange ? 'app.discard' : cancelMessageId || 'app.cancel'
        }
        __type={TYPES.SECONDARY}
        __className={s.button}
        onClick={this.discard}
        disabled={this.state.isSubmitting}
      />
      <Button
        messageId="app.save"
        __className={s.button}
        onClick={this.save}
        type="submit"
        disabled={
          !this.state.didChange ||
          this.state.isSubmitting ||
          this.state.invalidDate
        }
      />
    </div>
  );
}

Form.propTypes = {
  save: PropTypes.func,
  openConfirm: PropTypes.func,
  defaultValues: PropTypes.object,
};

export default Form;
